import React from 'react';
import { ClockIcon } from 'lucide-react';
export const UrgencyBanner = () => {
  return <div className="bg-amber-50 border-y border-amber-100 py-3 px-4 text-center flex items-center justify-center text-xs sm:text-sm text-gray-800 mb-4 sm:mb-6" data-id="element-211">
      <ClockIcon className="w-3 h-3 sm:w-4 sm:h-4 text-red-500 mr-1 sm:mr-2 flex-shrink-0" data-id="element-212" />
      <span data-id="element-213">
        <strong data-id="element-214">UPDATE:</strong> Elivara Compression Leggings Are Selling Out
        FAST! Grab Yours NOW to get up to 40% OFF + Fast FREE Shipping
      </span>
    </div>;
};